
import React, { useState, useRef, useEffect } from "react";

/**
 * DropDown personalizado (no usa <select> nativo)
 * Props:
 * - options: [{ value, label }]
 * - value: valor seleccionado
 * - onChange: function(e)
 * - placeholder: string
 * - className: string
 * - disabled: boolean
 */
const DropDown = ({ options = [], value, onChange, placeholder = "Seleccione...", className = "", disabled = false }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Cerrar el menú si se hace click fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selected = options.find((opt) => String(opt.value) === String(value));

  return (
    <div className={`relative w-full ${className}`} ref={ref}>
      <button
        type="button"
        className={`w-full border border-gray-300 p-3 rounded-lg bg-white text-left focus:outline-none focus:ring-2 focus:ring-blue-500 flex items-center justify-between ${open ? "ring-2 ring-blue-500" : ""} ${disabled ? "opacity-60 cursor-not-allowed bg-gray-100" : ""}`}
        onClick={() => !disabled && setOpen((o) => !o)}
        disabled={disabled}
      >
        <span className={selected ? "text-gray-900 font-medium" : "text-gray-400 font-normal"}>
          {selected ? selected.label : placeholder}
        </span>
        <span className="ml-2 text-gray-500">▼</span>
      </button>
      {open && !disabled && (
        <ul className="absolute z-50 mt-1 w-full max-h-56 overflow-auto bg-white border border-gray-200 rounded-lg shadow-lg py-1 text-base">
          {options.length === 0 && (
            <li className="px-4 py-2 text-gray-400">Sin opciones</li>
          )}
          {options.map((opt) => (
            <li
              key={opt.value}
              className={`px-4 py-2 cursor-pointer hover:bg-blue-100 ${String(opt.value) === String(value) ? "bg-blue-50 font-semibold" : ""}`}
              onClick={() => {
                onChange({ target: { value: opt.value } });
                setOpen(false);
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DropDown;
